/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { StorageBinList01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const storageBinList01ResetTimestamp = (
  state,
  { currentPage, sorts, filters, pageSize }
) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedResources: INITIAL_STATE.selectedResources,
  toStorageBinOptions: INITIAL_STATE.toStorageBinOptions,
  toStorageBinOption: INITIAL_STATE.toStorageBinOption
});

export const storageBinList01FetchStorageBinList01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const storageBinList01FetchStorageBinList01Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const storageBinList01AddSelectedResources = (state, { selectedResources }) => {
  const selectIds = state.selectedResources.map(value => value.id);
  return {
    ...state,
    selectedResources: [
      ...state.selectedResources,
      ...selectedResources.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const storageBinList01RemoveSelectedResources = (state, { selectedResources }) => {
  const selectIds = selectedResources.map(value => value.id);
  return {
    ...state,
    selectedResources: state.selectedResources.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const storageBinList01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const storageBinList01SetBarcodeVisible = (state, { boolean }) => ({
  ...state,
  barcodeDialogIsVisible: boolean
});

export const storageBinList01ShowBarcode = (state, { barcode, code, desc01, desc02 }) => ({
  ...state,
  barcodeDialogBarcode: barcode,
  barcodeDialogCode: code,
  barcodeDialogDesc01: desc01,
  barcodeDialogDesc02: desc02,
  barcodeDialogIsVisible: true
});

export const storageBinList01PrintStorageBinList01Loading = (state, { boolean }) => ({
  ...state,
  printIsLoading: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [StorageBinList01Types.STORAGE_BIN_LIST01_RESET_TIMESTAMP]: storageBinList01ResetTimestamp,
  [StorageBinList01Types.STORAGE_BIN_LIST01_FETCH_STORAGE_BIN_LIST01_LOADING]: storageBinList01FetchStorageBinList01Loading,
  [StorageBinList01Types.STORAGE_BIN_LIST01_FETCH_STORAGE_BIN_LIST01_SUCCESS]: storageBinList01FetchStorageBinList01Success,
  [StorageBinList01Types.STORAGE_BIN_LIST01_ADD_SELECTED_RESOURCES]: storageBinList01AddSelectedResources,
  [StorageBinList01Types.STORAGE_BIN_LIST01_REMOVE_SELECTED_RESOURCES]: storageBinList01RemoveSelectedResources,
  [StorageBinList01Types.STORAGE_BIN_LIST01_SET_WORKSPACE_VISIBLE]: storageBinList01SetWorkspaceVisible,
  [StorageBinList01Types.STORAGE_BIN_LIST01_SET_BARCODE_VISIBLE]: storageBinList01SetBarcodeVisible,
  [StorageBinList01Types.STORAGE_BIN_LIST01_SHOW_BARCODE]: storageBinList01ShowBarcode,
  [StorageBinList01Types.STORAGE_BIN_LIST01_PRINT_STORAGE_BIN_LIST01_LOADING]: storageBinList01PrintStorageBinList01Loading
});
